import { selectGroup, selectQuestion } from 'components-machine';
import { useMemo } from 'react';
import { ICState } from '../../../types/domain';
import { Poll as PollType } from '../../../types/poll.domain';

export function useTimerInfo({ poll, state: { groupId, questionId } }: { poll: PollType; state: ICState }) {
  return useMemo(() => {
    /** Глобальный таймер */
    if (poll.hasTimer) {
      return {
        timerDuration: poll.timerDuration,
        timerStrict: Boolean(poll.timerStrict),
        timerExpiredText: poll.timerExpiredText,
      };
    }

    /** Таймер на группу */
    if (groupId) {
      const group = selectGroup(poll, groupId);
      if (group.data.hasTimer) {
        return {
          timerDuration: group.data.timerDuration,
          timerStrict: Boolean(group.data.timerStrict),
          timerExpiredText: group.data.timerExpiredText,
        };
      }
      /** Таймер на вопрос */
    } else if (questionId) {
      const question: {
        data: Wide<{ hasTimer?: boolean; timerExpiredText?: string; timerStrict?: boolean; timerDuration?: number }>;
      } = selectQuestion(poll, questionId);

      if (question.data.hasTimer) {
        return {
          timerDuration: question.data.timerDuration,
          timerStrict: Boolean(question.data.timerStrict),
          timerExpiredText: question.data.timerExpiredText,
        };
      }
    }
    return null;
  }, [groupId, questionId, poll]);
}
